export const electricMeteringPointFields = {
  ID: 'id',
  EICZ_CODE: 'eicZ',
  LOADING_UNIT_NAME: 'loadingUnitName',
};
